import dynamic from "next/dynamic";

export const ParallaxBackground = dynamic(() => import("./component"));
